<template>

    <update-score :course_id="course_id" :type="type" />

</template>

<script>
import UpdateScore from "./UpdateScore.vue";

export default {
    name: "LaboratoryContinuousEvaluation",

    components: {
        UpdateScore
    },

    props: ["course_id"],

    data() {
        return {
            type: 'lab'
        };
    }
};
</script>
